import api from '../middleware/api';

/**
 * Service pour gérer les adresses côté frontend
 */

/**
 * Convertit les données d'adresse du format WooCommerce vers le format backend
 * @param {Object} wooCommerceAddress - Adresse au format WooCommerce
 * @returns {Object} - Adresse au format backend
 */
const mapWooCommerceToBackend = (wooCommerceAddress) => {
    return {
        street: wooCommerceAddress.address_1 || '',
        city: wooCommerceAddress.city || '',
        state: wooCommerceAddress.state || '',
        postcode: wooCommerceAddress.postcode || '',
        country: wooCommerceAddress.country || '',
        isoCountry: wooCommerceAddress.country || '', // Le backend gère la conversion ISO
        legalFirstname: wooCommerceAddress.first_name || '',
        legalLastname: wooCommerceAddress.last_name || '',
        isPrimary: false,
        ...(wooCommerceAddress.company && { company: wooCommerceAddress.company })

    };
};

/**
 * Crée une nouvelle adresse pour l'utilisateur connecté
 * @param {Object} addressData - Les données de l'adresse au format WooCommerce
 * @returns {Object} - Résultat de la création
 */
const createAddress = async (addressData) => {
    try {

        let data = addressData;
        if (addressData.hasOwnProperty('address_1')) {
            data = mapWooCommerceToBackend(addressData);
        }


        const response = await api.post('/addresses/therapist', data);
        return {
            success: true,
            address: response.data,
            error: null
        };
    } catch (error) {
        console.error('Erreur lors de la création de l\'adresse:', error);
        return {
            success: false,
            address: null,
            error: error.response?.data?.message || 'Erreur lors de la création de l\'adresse'
        };
    }
};

/**
 * Met à jour une adresse existante
 * @param {number} addressId - ID de l'adresse à mettre à jour
 * @param {Object} addressData - Les nouvelles données de l'adresse au format WooCommerce
 * @returns {Object} - Résultat de la mise à jour
 */
const updateAddress = async (addressId, addressData) => {
    try {
        // Convertir les données du format WooCommerce vers le format backend
        let data = addressData;
        if (addressData.hasOwnProperty('address_1')) {
            data = mapWooCommerceToBackend(addressData);
        }

        const response = await api.put(`/addresses/${addressId}`, data);
        return {
            success: true,
            address: response.data,
            error: null
        };
    } catch (error) {
        console.error('Erreur lors de la mise à jour de l\'adresse:', error);
        return {
            success: false,
            address: null,
            error: error.response?.data?.message || 'Erreur lors de la mise à jour de l\'adresse'
        };
    }
};

export default {
    createAddress,
    updateAddress
};